var map = {
	"./countries/ar.svg": 171,
	"./countries/br.svg": 172,
	"./countries/default.svg": 65,
	"./countries/mx.svg": 173,
	"./cryptos/arst.svg": 174,
	"./cryptos/bch.svg": 175,
	"./cryptos/bnb.svg": 176,
	"./cryptos/brlt.svg": 177,
	"./cryptos/btc.svg": 178,
	"./cryptos/dai.svg": 179,
	"./cryptos/dash.svg": 180,
	"./cryptos/default.svg": 66,
	"./cryptos/eos.svg": 181,
	"./cryptos/eth.svg": 182,
	"./cryptos/ltc.svg": 183,
	"./cryptos/neo.svg": 184,
	"./cryptos/ont.svg": 185,
	"./cryptos/rif.svg": 186,
	"./cryptos/trx.svg": 187,
	"./cryptos/tusd.svg": 188,
	"./cryptos/usdc.svg": 189,
	"./cryptos/usdt.svg": 190,
	"./cryptos/xlm.svg": 191,
	"./cryptos/xmr.svg": 192,
	"./cryptos/xrp.svg": 193,
	"./exchanges/Binance.svg": 39,
	"./exchanges/Bitso.svg": 41,
	"./exchanges/Bitstamp.svg": 42,
	"./exchanges/FTX.svg": 43,
	"./exchanges/Kraken.svg": 44,
	"./exchanges/Okex.svg": 40,
	"./exchanges/Other.svg": 45,
	"./exchanges/Ripio.svg": 38
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 170;